//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpTableHeadCell',
  props: {
    width: { type: [Number, String], default: null },
    align: { type: String, default: null },
    truncated: { type: Boolean, default: false },
  },
  computed: {
    widthString() {
      const { width } = this;
      if (!width) return null;
      return typeof width === 'string' ? width : `${width}px`;
    },
  },
};
